/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";

function Brands({ data }) {
  // Brand Categorization - Others
  if (data) {
    var Others = data.brands.map(function (Others) {
      if (Others.category === "Others" && Others.state === "Demo") {
        return (
          <div key={Others.title} className="columns portfolio-item">
            {/* <div className="item-wrap"> */}
            {/* <a href={top.url} title={top.title} target="_blank"> */}
            <img alt={Others.title} src={`${Others.image}`} />
            {/* <div className="overlay">
                  <div className="portfolio-item-meta">
                    <h5>{top.title}</h5>
                  </div>
                </div> */}
            {/* </a> */}
            {/* </div> */}
          </div>
        );
      }
    });
  }

  if (data) {
    var eCom = data.brands.map(function (eCom) {
      if (eCom.category === "eCom" && eCom.state === "Demo") {
        return (
          <div key={eCom.title} className="columns portfolio-item">
            <img alt={eCom.title} src={`${eCom.image}`} />
          </div>
        );
      }
    });
  }

  // Brand Categorization - Stock Market
  if (data) {
    var Electronics = data.brands.map(function (Elec) {
      if (Elec.category === "Electronics" && Elec.state === "Demo") {
        return (
          <div key={Elec.title} className="columns portfolio-item">
            <img alt={Elec.title} src={`${Elec.image}`} />
          </div>
        );
      }
    });
  }

  // Brand - Gaming
  if (data) {
    var Gaming = data.brands.map(function (Gaming) {
      if (Gaming.category === "Gaming" && Gaming.state === "Demo") {
        return (
          <div key={Gaming.title} className="columns portfolio-item">
            <img alt={Gaming.title} src={`${Gaming.image}`} />
          </div>
        );
      }
    });
  }

  // Brand - Health & Beauty
  if (data) {
    var HnB = data.brands.map(function (HnB) {
      if (HnB.category === "HnB" && HnB.state === "Demo") {
        return (
          <div key={HnB.title} className="columns portfolio-item">
            <img alt={HnB.title} src={`${HnB.image}`} />
          </div>
        );
      }
    });
  }

  // Brand - Health & Beauty
  if (data) {
    var CnH = data.brands.map(function (CnH) {
      if (CnH.category === "CnH" && CnH.state === "Demo") {
        return (
          <div key={CnH.title} className="columns portfolio-item">
            <img alt={CnH.title} src={`${CnH.image}`} />
          </div>
        );
      }
    });
  }

  // Brand - Online Delivery
  if (data) {
    var OnlineD = data.brands.map(function (OnlineD) {
      if (OnlineD.category === "OnlineD" && OnlineD.state === "Demo") {
        return (
          <div key={OnlineD.title} className="columns portfolio-item">
            <img alt={OnlineD.title} src={`${OnlineD.image}`} />
          </div>
        );
      }
    });
  }

  // Brand - finance
  if (data) {
    var Finance = data.brands.map(function (Finance) {
      if (Finance.category === "Finance" && Finance.state === "Demo") {
        return (
          <div key={Finance.title} className="columns portfolio-item">
            <img alt={Finance.title} src={`${Finance.image}`} />
          </div>
        );
      }
    });
  }

  return (
    <div className="Brands-main">
      <div className="Brands">
        <h2>Brands Collaborated With</h2>
        <div className="BCats">
          <h3>E-commerce & Retails</h3>
          <div className="grid-wrapperB">{eCom}</div>
        </div>
        <div className="BCats">
          <h3>Financial Services</h3>
          <div className="grid-wrapperB2">{Finance}</div>
        </div>
        <div className="BCats">
          <h3>Online Delivery</h3>
          <div className="grid-wrapperB">{OnlineD}</div>
        </div>
        <div className="BCats">
          <h3>Online Gaming & Streaming</h3>
          <div className="grid-wrapperB">{Gaming}</div>
        </div>
        <div className="BCats">
          <h3>Electronics</h3>
          <div className="grid-wrapperB2">{Electronics}</div>
        </div>
        <div className="BCats">
          <h3>Health & Beauty</h3>
          <div className="grid-wrapperB2">{HnB}</div>
        </div>
        <div className="BCats">
          <h3>Cleaning & Households</h3>
          <div className="grid-wrapperB">{CnH}</div>
        </div>
        <div className="BCats">
          <h3>Other Brands</h3>
          <div className="grid-wrapperB2">{Others}</div>
        </div>
      </div>
    </div>
  );
}

export default Brands;
